<ng-container
  *ngIf="
    assignmentDetailsState$ | async as assignmentDetailsState;
    else loading
  "
>
  <ng-container *ngIf="assignmentDetailsState.loaded; else loading">
    <ng-container *ngIf="displaySettings$ | async as displaySettings">
      <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg shadow" role="document">
          <div class="modal-content">
            <div class="modal-header d-flex justify-content-center">
              <div
                *ngIf="displaySettings.loaded; else loading"
                class="card-body"
              >
                <h5 class="modal-title">
                  Resultaten {{ assignmentDetailsState?.candidate?.name }}
                </h5>
              </div>

              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                (click)="close()"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" *ngIf="assignment$ | async as assignment">
              <p class="header-text">
                <img
                  id="icon"
                  [appPlannerIndicator]="assignment?.status"
                  #icon
                  width="30"
                  height="30"
                />{{ assignment?.learningObjectiveTitle }}
              </p>
              <div
                *ngIf="displaySettings.showAction"
                class="popover-actions"
                [style.top]="actionsTop + 'px'"
                [style.left]="actionsLeft + 'px'"
              >
                <div class="aarrow"></div>
                <div class="popover-content">
                  <app-status-button-group (clickOutside)="hideActions($event)">
                  </app-status-button-group>
                </div>
              </div>
              <div class="modal-body">
                <tabset type="pills" #staticTabs>
                  <tab heading="Review" (selectTab)="hideLog()">
                    <ng-container
                      *ngIf="selectedResult$ | async as selectedResult"
                    >
                      <ng-container *ngIf="!selectedResult.hasData">
                        <p class="header-text">
                          Er zijn geen afnamedata beschikbaar.
                        </p>
                      </ng-container>
                      <ng-container
                        *ngIf="
                          selectedResult.hasData &&
                          assignmentDetailsState.currentReview as reviewData
                        "
                      >
                        <div class="d-flex justify-content-center">
                          <div class="flex-grow-1">
                            <h3 class="iframe-header">
                              {{ assignmentDetailsState?.candidate?.name }}
                            </h3>
                            <div class="iframe-wrap">
                              <iframe
                                scrolling="no"
                                class="iframe-scale"
                                id="iframe-response"
                                allow="autoplay"
                                [src]="reviewUrl"
                                border="0"
                              >
                              </iframe>
                            </div>
                          </div>
                          <div class="flex-grow-1">
                            <h3 class="iframe-header">
                              {{ "CORRECT_ANSWER" | translate }}
                            </h3>
                            <div class="iframe-wrap">
                              <iframe
                                scrolling="no"
                                class="iframe-scale"
                                id="iframe-correct"
                                allow="autoplay"
                                [src]="correctUrl"
                                border="0"
                              >
                              </iframe>
                            </div>
                          </div>
                        </div>

                        <div class="d-flex justify-content-center">
                          <button
                            *ngFor="
                              let item of selectedResult.result.items;
                              let i = index
                            "
                            (click)="reviewItem(item.itemId)"
                            class="btn mx-1 mdi"
                            [class.mdi-close]="item?.rawScore == 0"
                            [class.mdi-check]="item?.rawScore > 0"
                            [class.btn-danger]="
                              item?.rawScore == 0 &&
                              item?.itemId === reviewData?.id
                            "
                            [class.btn-success]="
                              item?.rawScore > 0 &&
                              item?.itemId === reviewData?.id
                            "
                            [class.btn-outline-danger]="
                              item?.rawScore == 0 &&
                              item?.itemId !== reviewData?.id
                            "
                            [class.btn-outline-success]="
                              item?.rawScore > 0 &&
                              item?.itemId !== reviewData?.id
                            "
                          ></button>
                        </div>
                      </ng-container>
                    </ng-container>
                  </tab>
                  <tab heading="Historie" (selectTab)="showLog()">
                    <ul class="list-group">
                      <li
                        class="list-group-item d-flex align-items-center"
                        [style.background-color]="
                          logEvent.assignmentAction === 4 ||
                          logEvent.assignmentAction === 5
                            ? '#fff'
                            : '#eaeaea'
                        "
                        [class.c-pointer]="
                          logEvent.assignmentAction === 4 ||
                          logEvent.assignmentAction === 5
                        "
                        (click)="
                          showAssessmentResult(
                            logEvent.assignmentAction,
                            logEvent.testSessionId
                          )
                        "
                        *ngFor="
                          let logEvent of assignmentDetailsState.logEvents
                        "
                      >
                        <img
                          [appPlannerIndicator]="logEvent?.assignmentAction"
                          class="cell"
                          width="30"
                          height="30"
                        />
                        <span>{{ logEvent.message }}</span>
                      </li>
                    </ul>
                  </tab>
                </tabset>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
<ng-template #loading>
  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg shadow" role="document">
      <div class="modal-content">
        <img
          src="assets/loader/loader.svg"
          style="
            position: absolute;
            height: 50px;
            width: 50px;
            top: 50px;
            left: 50px;
            right: 0;
          "
        />
      </div>
    </div>
  </div>
</ng-template>
